<template>
    <div class="sidebar flex x-left">
        <div class="sidebar-menu flex flex-column" :style="{ width: sidebarMenuWidth + 'px' }">
            <div class="logo"></div>
            <div class="sidebar-menu-wrapper">
                <div class="sidebar-menu-list flex-item" :style="{ width: sidebarMenuWidth + 20 + 'px' }">
                    <div
                        @click="handleClickMenuEvent(index)"
                        v-for="(item, index) in navList"
                        :class="{ selected: current1 == item.id }"
                        :key="index"
                        class="sidebar-menu-item"
                        :style="{ width: sidebarMenuWidth + 'px' }"
                    >
                        <i style="display: inline-block; height: 20px" class="fs18 medcon" :class="item.module_marking"></i>
                        <p class="fs14 sidebar-menu-item-title">{{ item.module_name }}</p>
                    </div>
                </div>
            </div>
        </div>
        <transition name="translate">
            <div v-if="subNavList.length && menubar" class="sidebar-submenu">
                <div class="logo-text">
                    <p class="fs16 strong t-c">美迪康会务通</p>
                </div>
                <div class="sidebar-submenu-wrapper">
                    <div class="sidebar-submenu-list flex-item">
                        <a-menu class="sidebar-submenu-content" v-model="current2" :open-keys.sync="openKeys" mode="inline" :inlineIndent="20" >
                            <template v-for="item in subNavList">
                                <a-menu-item v-if="!item.list?.length" @click="handleClickEvent(item, 2)" :key="item.id">
                                    <i v-if="item.module_marking" :class="item.module_marking" class="fs20 medcon sub-iconfont"></i>
                                    {{ item.module_name }}
                                </a-menu-item>
                                <a-sub-menu v-else :key="item.id">
                                    <div slot="title">
                                        <i v-if="item.module_marking" :class="item.module_marking" class="fs20 medcon sub-iconfont"></i>
                                        <b>
                                            {{ item.module_name }}
                                        </b>
                                    </div>
                                    <a-menu-item @click="handleClickEvent(it, 3)" v-for="it in item.list" :key="it.id">
                                        <i v-if="it.module_marking" :class="it.module_marking" class="fs20 medcon sub-iconfont"></i>
                                        {{ it.module_name }}
                                    </a-menu-item>
                                </a-sub-menu>
                            </template>
                        </a-menu>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'AdminSidebar',
    components: {},
    props: {
        menubar: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            current1: 0,
            // 子路由
            subNavList: [],
            // 打开分组的key
            openKeys: [],
            // 当前选择的key
            current2: []
        };
    },
    computed: {
        ...mapState('asidebar', ['navList']),
        sidebarMenuWidth() {
            return this.$route.params.lang === 'cn' ? 60 : 80;
        }
    },

    // 监听首次渲染路由
    watch: {
        // 一级路由监听
        navList: {
            handler(newVal) {
                this.listToTree(newVal, level => {
                    if (level?.length >= 1) {
                        this.current1 = level[0];
                        let subNavList = newVal.filter(it => it.id == this.current1);
                        if (subNavList.length) {
                            this.subNavList = subNavList[0]?.list || [];
                        }
                    }
                    if (level?.length >= 2) {
                        this.current2 = [level[1]];
                    }
                    if (level?.length >= 3) {
                        this.current2 = [level[2]];
                    }
                });
            },
            immediate: true
        },

        // 二级路由监听
        subNavList: {
            handler(list) {
                this.openKeys = [];
                list.forEach(it => {
                    this.openKeys.push(String(it.id));
                });
            },
            immediate: true
        }
    },

    methods: {
        // 递归获取当前路由
        listToTree(list, callback) {
            for (let i = 0, len = list.length; i < len; i++) {
                let item = list[i];
                if (item.name == this.$route.name) {
                    let level = String(item.level).split('_');
                    callback(level);
                    // 动态设置四级
                    if (level.length >= 4) {
                        // 更新四级路由
                        this.$store.commit('updateState', { 'asidebar.fourRouteList': list });
                    }
                    break;
                } else {
                    item?.list?.length && this.listToTree(item?.list, callback);
                }
            }
        },

        // 点击一级菜单事件
        handleClickMenuEvent(index) {
            let currItem = this.navList[index] || {};
            this.current1 = currItem.id;
            if (currItem.path) {
                this.subNavList = [];
                // 路由跳转
                this.navigateFun(currItem.path, []);
            } else {
                // 找下级路由
                this.subNavList = currItem?.list || [];
                // 递归查询下级路由
                this.triggerSubRouteFun(this.subNavList, 1);
            }
            this.$emit('menubar-change', true);
        },

        // 默认触发下级路由(递归往下找，知道找到最后一级)
        triggerSubRouteFun(list, level) {
            ++level;
            if (list.length) {
                let subCurrItem = list[0];
                // 选中二级或者三级
                if (level == 2 || level == 3) {
                    this.current2 = [subCurrItem.id];
                }
                if (subCurrItem.list.length) {
                    this.triggerSubRouteFun(subCurrItem.list, level);
                } else {
                    // 如果不是外链则默认打开第一条
                    if ((subCurrItem?.path || '').indexOf('http') == -1) {
                        this.navigateFun(subCurrItem?.path, level == 4 ? list : []);
                    }
                }
            }
        },

        // 点击二级菜单事件
        handleClickEvent(item, level) {
            let path = item.path;
            if (path) {
                // 路由跳转
                this.navigateFun(path, level == 4 ? item.list : []);
            } else {
                // 找下级路由
                this.triggerSubRouteFun(item.list, level);
            }
        },

        // 路由跳转
        navigateFun(path, fourRoute) {
            console.log(path);
            // 更新四级路由
            this.$store.commit('updateState', { 'asidebar.fourRouteList': fourRoute });
            if (!path) {
                return false;
            }
            let { lang, meeting_id, forum_id } = this.$route.params;
            path = path.replace(':lang', lang).replace(':meeting_id', meeting_id).replace(':forum_id', forum_id);
            if (path.indexOf('http') != -1) {
                window.open(path, '_blank');
            } else {
                this.$router.push(path);
            }
        }
    },
    mounted() {
    },
    beforeDestroy() {
    }
};
</script>

<style lang="less" scoped>
@sidebar-submenu-width: 180px;
.sidebar {
    height: 100%;
    &-menu {
        height: 100%;
        background: @theme;
        .logo {
            flex: 0 0 50px;
            background: url(~@/assets/images/logo.png) no-repeat center center;
            background-size: 65% auto;
        }
        &-wrapper {
            width: 100%;
            height: 100%;
            overflow: hidden;
        }
        &-list {
            height: 100%;
            box-sizing: border-box;
            overflow: auto;
        }
        &-item {
            height: 60px;
            display: flex;
            flex-direction: column;
            color: #fff;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            &-title {
                margin-top: 2px;
                font-weight: bold;
            }
            &.selected {
                background-color: @theme-active;
            }
        }
    }
    &-submenu {
        height: 100%;
        background-color: #fff;
        .logo-text {
            width: @sidebar-submenu-width;
            line-height: 50px;
            box-shadow: 0 2px 8px #f0f1f2;
            margin-bottom: 15px;
        }
        &-wrapper {
            width: 100%;
            height: calc(100% - 65px);
            overflow: hidden;
        }
        &-list {
            width: @sidebar-submenu-width;
            height: 100%;
            box-sizing: border-box;
            overflow: auto;
        }
        &-content {
            width: @sidebar-submenu-width;
            box-sizing: border-box;
            height: 50px;
            line-height: 50px;
            text-align: left;
            cursor: pointer;
            /deep/.ant-menu-sub.ant-menu-inline > .ant-menu-item {
                padding-left: 35px !important;
            }
        }
    }
}

.sub-iconfont {
    position: relative;
    top: 2px;
    display: inline-block;
    text-align: center;
    width: 25px;
    margin-left: -10px;
}

// 动画
// 元素开始进入的状态 | 元素离开结束的状态
.translate-enter-from,
.translate-leave-to {
    width: 0;
}

.translate-enter-active {
    width: 0;
}

.translate-leave-from,
.translate-enter-to {
    width: @sidebar-submenu-width;
}

// 元素进入 ｜ 结束时，过渡的效果
.translate-enter-active,
.translate-leave-active {
    // 过渡动画的使用
    transition: all 0.15s linear;
}

</style>
